import { Button } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useBreadCrumb from "../hooks/useBreadCrumb";


export default function Settings() {
  const navigate = useNavigate();
  const location = useLocation();
  useBreadCrumb("Settings", location.pathname, "Settings");

  return (
    <div className="dashboard">
      <div className="section_row">
        <div className="top_row">
          <Button
            className="primary__btn"
            onClick={() => navigate("/user-management/invite-user")}
          >
            Invite User
          </Button>
          <Button
            className="default__btn"
            onClick={() => navigate("/user-management/create-user")}
          >
            Add User
          </Button>
          <Button className="default__btn">
            Export
          </Button>
        </div>
        {/* <UserDataTable /> */}
      </div>
    </div>
  );
}
